"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.default = (function () { return (React.createElement("div", { className: 'dashboard-elements' },
    React.createElement("h2", null, "Project data"))); });
